import * as React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

interface Policy {
  Product: {
    ProductCategory: {
      MinAge: number;
      MaxAge: number;
    };
  };
}

interface PolicyProps {
  policies: Policy[];
}

const ageRanges = [
  { label: "Under 65", min: 20, max: 64 },
  { label: "Under 75", min: 65, max: 74 },
  { label: "Under 85", min: 75, max: 84 },
  { label: "Above 85", min: 85, max: Infinity },
];

const PolicyPerAgeChart: React.FC<PolicyProps> = ({ policies }) => {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
  );

  // Function to calculate counts for each age range
  const getCountsByAgeRange = () => {
    const validPolicies = policies.filter(
      (policy) => policy?.Product?.ProductCategory
    );

    return ageRanges.map((range) => {
      return validPolicies.reduce((count: number, policy: Policy) => {
        if (policy.Product && policy.Product.ProductCategory) {
          const { MinAge, MaxAge } = policy.Product.ProductCategory;
          // Check if the policy falls into the current age range
          if (
            (MinAge >= range.min && MinAge <= range.max) ||
            (MaxAge >= range.min && MaxAge <= range.max) ||
            (MinAge < range.min && MaxAge > range.max)
          ) {
            count += 1;
          }
        }
        return count;
      }, 0);
    });
  };

  const counts = getCountsByAgeRange();

  const options = {
    responsive: true,
    scales: {
      x: {
        display: true,
        grid: {
          display: false,
        },
      },
      y: {
        grid: {
          display: false,
        },
      },
    },
    plugins: {
      legend: {
        position: "top" as const,
        display: true,
      },
      title: {
        text: "Number of Policies",
      },
    },
    tension: 0.5,
  };

  const data = {
    labels: ageRanges.map((range) => range.label),
    datasets: [
      {
        label: "Number of Policies",
        data: counts,
        borderColor: "#f04f05",
        backgroundColor: "rgba(240, 79, 5, 0.1)",
        fill: true,
      },
    ],
  };

  return (
    <>
      <Line height={"100%"} options={options} data={data} />
    </>
  );
};

export default PolicyPerAgeChart;
